import { combineReducers } from 'redux';

import userTribunTokenReducer from './userTribunTokenReducer';
import tribunUserReducer from './tribunUserReducer';
import tribunAnotherUserReducer from './tribunAnotherUserReducer';
import tribunNotificationsReducer from './tribunNotificationsReducer';
import profilTribunUsersReducer from './profilTribunUsersReducer';
import allTribunCouponsReducer from './allTribunCouponsReducer';
import tribunCouponDetailsReducer from './tribunCouponDetailsReducer';
import popularTribunUsersReducer from './popularTribunUsersReducer';
import followingTribunUsersReducer from './followingTribunUsersReducer';
import winnerTribunUsersReducer from './winnerTribunUsersReducer';
import shareTribunCouponReducer from './shareTribunCouponReducer';
import tribunSearchReducer from './tribunSearchReducer';
import tribunVerifyReducer from './tribunVerifyReducer';
import showOrHideCouponReducer from './showOrHideCouponReducer';
import commentReducer from './commentReducer';
import complaintTribunReducer from './complaintTribunReducer';
import tribunLeaderBoardReducer from './tribunLeaderBoardReducer';
import leaderTribunUsersReducer from './leaderTribunUsersReducer';
import tribunMiniLeaderBoardReducer from './tribunMiniLeaderBoardReducer';
import tribunUserAgreementReducer from './tribunUserAgreementReducer';
import tribunLastCouponsReducer from './tribunLastCouponsReducer';
import tribunWatchingUserReducer from './tribunWatchingUserReducer';
import tribunSpaceCouponReducer from './tribunSpaceCouponReducer';
import tribunTermOfUseReducer from './tribunTermOfUseReducer';
import tribunCouponNameReducer from './tribunCouponNameReducer';
import segmentTribunReducer from './segmentTribunReducer';
import tribunSortingReducer from './tribunSortingReducer';
import muteTribunUserReducer from './muteTribunUserReducer';
import hideTribunFeedCouponReducer from './hideTribunFeedCouponReducer';
import followTribunUserReducer from './followTribunUserReducer';


export default combineReducers({
  allTribunCoupons: allTribunCouponsReducer,
  tribunCouponDetails: tribunCouponDetailsReducer,
  tribunNotifications: tribunNotificationsReducer,
  userTribunToken: userTribunTokenReducer,
  tribunUser: tribunUserReducer,
  popularTribunUsers: popularTribunUsersReducer,
  followingTribunUsers: followingTribunUsersReducer,
  winnerTribunUsers: winnerTribunUsersReducer,
  shareTribunCoupon: shareTribunCouponReducer,
  tribunAnotherUser: tribunAnotherUserReducer,
  profilTribun: profilTribunUsersReducer,
  tribunSearch: tribunSearchReducer,
  tribunVerify: tribunVerifyReducer,
  showOrHideCoupon: showOrHideCouponReducer,
  comment: commentReducer,
  complaintTribun: complaintTribunReducer,
  tribunLeaderBoard: tribunLeaderBoardReducer,
  leaderTribunUsers: leaderTribunUsersReducer,
  tribunMiniLeaderBoard: tribunMiniLeaderBoardReducer,
  tribunUserAgreement: tribunUserAgreementReducer,
  tribunLastCoupons: tribunLastCouponsReducer,
  tribunWatchingUser: tribunWatchingUserReducer,
  tribunSpaceCoupon: tribunSpaceCouponReducer,
  tribunTermOfUse: tribunTermOfUseReducer,
  tribunCouponName: tribunCouponNameReducer,
  segment: segmentTribunReducer,
  tribunSortingOptions: tribunSortingReducer,
  muteTribunUser: muteTribunUserReducer,
  hideTribunFeedCoupon: hideTribunFeedCouponReducer,
  followTribunUser: followTribunUserReducer,

});
